import { Color, Icon, IconName, Text } from '@billy/design-system'
import { ReactElement, useCallback } from 'react'

import { OnboardingUserIntent } from '../../../../../../enums/onboardingUserIntent'
import * as Styled from './styles'

interface IntentTileProps {
  disabled?: boolean
  hasError: boolean
  icon: IconName
  id: OnboardingUserIntent
  isSelected: boolean
  label: string
  onClick: (id: OnboardingUserIntent) => void
}

export const IntentTile = ({
  disabled,
  hasError,
  icon,
  id,
  isSelected,
  label,
  onClick,
}: IntentTileProps): ReactElement => {
  const handleIntentTileClick = useCallback(() => onClick(id), [id, onClick])

  return (
    <Styled.IntentTileWrapper
      aria-pressed={isSelected}
      disabled={disabled}
      hasError={hasError}
      isSelected={isSelected}
      onClick={handleIntentTileClick}
      type="button"
    >
      <Styled.IntentTileTopRow>
        <Icon icon={icon} size="md" color={Color.Black} />
        <Styled.SelectionIndicator aria-hidden="true" isSelected={isSelected}>
          <Styled.CheckIconWrapper isSelected={isSelected}>
            <Icon color={Color.White} icon="check" size="xs" />
          </Styled.CheckIconWrapper>
        </Styled.SelectionIndicator>
      </Styled.IntentTileTopRow>
      <Styled.IntentTileItemWrapper>
        <Text variant="bodyLG">{label}</Text>
      </Styled.IntentTileItemWrapper>
    </Styled.IntentTileWrapper>
  )
}
